import styled from 'styled-components';

import { RewardsStyleVariant, WithStyleVariant } from '../types';

export const CategoryContainer = styled.div<WithStyleVariant>`
  padding: 0 1rem;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ variant }) =>
    variant === RewardsStyleVariant.Secondary ? '#990019' : Styles.color.grey.four};
  border-radius: 0.25rem;
  background-color: ${({ variant }) =>
    variant === RewardsStyleVariant.Secondary ? '#990019' : Styles.color.white};
`;
